import "core-js/modules/es.array.index-of";
import { toDisplayString as _toDisplayString, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue";
var _hoisted_1 = {
  class: "title is-4"
};
var _hoisted_2 = {
  class: "subtitle"
};

var _hoisted_3 = /*#__PURE__*/_createVNode("hr", null, null, -1);

var _hoisted_4 = {
  class: "level"
};
var _hoisted_5 = {
  class: "level-item has-text-centered"
};

var _hoisted_6 = /*#__PURE__*/_createVNode("figure", {
  class: "image is-64x64"
}, [/*#__PURE__*/_createVNode("img", {
  class: "is-rounded",
  src: "https://avatars0.githubusercontent.com/u/243300?s=460&v=4",
  alt: "avatar of Tiago J C Oliveira"
})], -1);

var _hoisted_7 = {
  class: "heading"
};

var _hoisted_8 = /*#__PURE__*/_createVNode("div", {
  class: "level-item has-text-centered"
}, [/*#__PURE__*/_createVNode("div", {
  class: ""
}, [/*#__PURE__*/_createVNode("span", {
  class: "icon h50 has-text-info"
}, [/*#__PURE__*/_createVNode("i", {
  class: "fas fa-building fa-3x"
})]), /*#__PURE__*/_createVNode("p", {
  class: "heading"
}, "Unimed JP")])], -1);

var _hoisted_9 = /*#__PURE__*/_createVNode("div", {
  class: "level-item has-text-centered"
}, [/*#__PURE__*/_createVNode("div", {
  class: ""
}, [/*#__PURE__*/_createVNode("span", {
  class: "icon h50"
}, [/*#__PURE__*/_createVNode("i", {
  class: "fas fa-map-marker-alt fa-3x"
})]), /*#__PURE__*/_createVNode("p", {
  class: "heading"
}, "João Pessoa, Paraíba, Brasil")])], -1);

var _hoisted_10 = /*#__PURE__*/_createVNode("hr", null, null, -1);

var _hoisted_11 = {
  class: "timeline-header"
};
var _hoisted_12 = {
  class: "tag is-link is-uppercase"
};
var _hoisted_13 = {
  class: "timeline-content"
};
var _hoisted_14 = {
  class: "box"
};
var _hoisted_15 = {
  class: "heading"
};

var _hoisted_16 = /*#__PURE__*/_createVNode("header", {
  class: "timeline-header"
}, [/*#__PURE__*/_createVNode("span", {
  class: "tag is-primary"
}, " 1982 ")], -1);

export function render(_ctx, _cache) {
  return _openBlock(), _createBlock("div", {
    id: "v-about",
    class: "container",
    alt: _ctx.locale
  }, [_createVNode("h3", _hoisted_1, _toDisplayString(_ctx.t("message.views.about.title")), 1), _createVNode("h4", _hoisted_2, _toDisplayString(_ctx.t("message.views.about.subtitle")), 1), _hoisted_3, _createVNode("div", _hoisted_4, [_createVNode("div", _hoisted_5, [_createVNode("div", null, [_hoisted_6, _createVNode("p", _hoisted_7, _toDisplayString(new Date().getYear() + 1900 - 1982) + " anos 😉 ", 1)])]), _hoisted_8, _hoisted_9]), _hoisted_10, _createVNode("div", {
    class: ['timeline', {
      'is-centered': !_ctx.isMobile()
    }]
  }, [_createVNode("header", _hoisted_11, [_createVNode("span", _hoisted_12, _toDisplayString(_ctx.t("message.views.about.timeline")), 1)]), (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.timelineEntries, function (x) {
    return _openBlock(), _createBlock("div", {
      class: "timeline-item",
      key: x.id
    }, [_createVNode("div", {
      class: 'timeline-marker ' + _ctx.timelineClass(x.type)
    }, [_ctx.timelineClass(x.type).indexOf('is-icon') != -1 ? (_openBlock(), _createBlock("i", {
      key: 0,
      class: _ctx.timelineMarkerIcon(x.type)
    }, null, 2)) : _createCommentVNode("", true)], 2), _createVNode("div", _hoisted_13, [_createVNode("div", _hoisted_14, [_createVNode("p", _hoisted_15, _toDisplayString(x.timestamp), 1), _createVNode("p", null, [_createVNode("span", {
      innerHTML: x.event[_ctx.locale]
    }, null, 8, ["innerHTML"])])])])]);
  }), 128
  /* KEYED_FRAGMENT */
  )), _hoisted_16], 2)], 8, ["alt"]);
}